import Lang from 'ln/lang/Lang';
import CourseElement from './CourseElement';
import UserSequenceModel from '../models/UserSequenceModel';
import CoursePreview from './CoursePreview';


class SequencePreview extends CourseElement {

	
	constructor( public model:UserSequenceModel, private courseView: CoursePreview ) {
		super( model, courseView );
	}
	
	public init(){
		super.init();
		
		this.renderDisplayTime();

		this.blankLinks();

	}
	

	protected renderDisplayTime() {
		this.node.js('display-time').html = this.model.displayTime + ' ' + Lang.translate( 'processplan.time' );
	}
	
}

export default SequencePreview;